import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import Icon from '../Icon';
import closeIcon from '../../Assets/Icons/close.svg';
import { useIsLandscape } from '~Scenes/SelfServiceKiosks/Hooks/useIsLandscape';

const Container = styled.div<{ visible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  z-index: 1000;
  display: flex;
  flex-direction: column;

  transition: transform 0.35s, background-color 0.5s 0.35s, opacity 0.4s;
  transform: translateY(${({ visible }) => (visible ? 0 : 100)}vh);
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  background-color: rgba(0, 0, 0, ${({ visible }) => (visible ? 0.5 : 0)});
`;

const Wrapper = styled.div`
  flex: 1;
  border-radius: 80px 80px 0px 0px;
  background: rgb(255, 255, 255);
  overflow: hidden;
  position: relative;

  @media (orientation: landscape) {
    width: 1080px;
    margin: 0 auto;
  }
`;

const CloseWrapper = styled.div<{ visible: boolean }>`
  height: 232px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  transition: opacity 0.4s 0.2s;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  padding: 0 0 48px 0;

  @media (orientation: landscape) {
    height: 130px;
    padding: 0 0 27px 0;
  }
`;

const CloseInner = styled.div``;

const CloseButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(255, 255, 255);
  border-radius: 36px;
  height: 96px;
  width: 96px;

  @media (orientation: landscape) {
    height: 72px;
    width: 72px;
    border-radius: 27px;
  }
`;

const CloseButtonText = styled.div<{ height?: number }>`
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(255, 255, 255);
  border-radius: 36px;
  height: ${({ height }) => (height ? `${height}px` : '96px')};
  padding: 0 41px;
  color: rgb(33, 33, 36);
  font-family: Eina01-SemiBold;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.24px;
  line-height: 20px;
  text-align: center;

  @media (orientation: landscape) {
    border-radius: 20px;
  }
`;

type Props = {
  children: React.ReactNode;
  visible: boolean;
  onClose: () => void;
  initialCloseText: string | null;
  canClose: boolean;
};
const Dialog = ({ children, visible, onClose, initialCloseText, canClose }: Props) => {
  const [closeText, setCloseText] = useState<string | null>(null);
  const isLandscape = useIsLandscape();

  useEffect(() => {
    if (visible) {
      setCloseText(initialCloseText);
    }
  }, [visible]);

  return (
    <Container visible={visible}>
      <CloseWrapper visible={visible} onClick={canClose ? onClose : undefined}>
        {canClose && (
          <CloseInner>
            {closeText ? (
              <CloseButtonText height={isLandscape ? 72 : 88}>{closeText}</CloseButtonText>
            ) : (
              <CloseButton>
                <Icon icon={closeIcon} color={'#131316'} size={isLandscape ? 37 : 50} />
              </CloseButton>
            )}
          </CloseInner>
        )}
      </CloseWrapper>
      <Wrapper>{children}</Wrapper>
    </Container>
  );
};

export default Dialog;
